// SNIGJ - Internationalization (French/English + National Languages)
// Langues nationales: Lingala, Swahili, Kikongo, Tshiluba

const translations = {
  fr: {
    // Navigation
    nav: {
      dashboard: "Tableau de bord",
      cases: "Dossiers judiciaires",
      prisoners: "Détenus",
      documents: "Documents",
      payments: "Paiements",
      borderControl: "Contrôle frontalier",
      clemency: "Grâce présidentielle",
      admin: "Administration",
      auditLogs: "Journaux d'audit",
      settings: "Paramètres",
      logout: "Déconnexion"
    },
    // Auth
    auth: {
      login: "Connexion",
      register: "Inscription",
      email: "Adresse e-mail",
      password: "Mot de passe",
      confirmPassword: "Confirmer le mot de passe",
      name: "Nom complet",
      loginButton: "Se connecter",
      registerButton: "S'inscrire",
      googleLogin: "Continuer avec Google",
      noAccount: "Pas de compte ?",
      hasAccount: "Déjà un compte ?",
      forgotPassword: "Mot de passe oublié ?",
      welcome: "Bienvenue au SNIGJ",
      subtitle: "Système National Intégré de Gestion de la Justice"
    },
    // Dashboard
    dashboard: {
      title: "Tableau de bord",
      totalCases: "Total des dossiers",
      openCases: "Dossiers ouverts",
      totalPrisoners: "Total des détenus",
      pendingPayments: "Paiements en attente",
      activeAlerts: "Alertes actives",
      recentActivity: "Activité récente",
      quickActions: "Actions rapides",
      newCase: "Nouveau dossier",
      newPrisoner: "Nouveau détenu",
      newDocument: "Nouveau document",
      viewAll: "Voir tout"
    },
    // Cases
    cases: {
      title: "Dossiers judiciaires",
      newCase: "Nouveau dossier",
      caseNumber: "Numéro de dossier",
      caseType: "Type de dossier",
      criminal: "Pénal",
      civil: "Civil",
      administrative: "Administratif",
      status: "Statut",
      open: "Ouvert",
      inProgress: "En cours",
      pending: "En attente",
      closed: "Fermé",
      archived: "Archivé",
      classification: "Classification",
      jurisdiction: "Juridiction",
      parties: "Parties",
      charges: "Chefs d'accusation",
      description: "Description",
      createdAt: "Créé le",
      updatedAt: "Mis à jour le",
      actions: "Actions",
      view: "Voir",
      edit: "Modifier",
      delete: "Supprimer"
    },
    // Prisoners
    prisoners: {
      title: "Registre des détenus",
      newPrisoner: "Nouveau détenu",
      unji: "Identifiant National (UNJI)",
      firstName: "Prénom",
      lastName: "Nom",
      dateOfBirth: "Date de naissance",
      gender: "Sexe",
      male: "Masculin",
      female: "Féminin",
      nationality: "Nationalité",
      status: "Statut",
      preventive: "Détention préventive",
      sentenced: "Condamné",
      released: "Libéré",
      transferred: "Transféré",
      prison: "Prison",
      cell: "Cellule",
      admissionDate: "Date d'admission",
      sentenceStart: "Début de peine",
      sentenceEnd: "Fin de peine",
      biometricPhoto: "Photo biométrique",
      fingerprint: "Empreinte digitale"
    },
    // Documents
    documents: {
      title: "Gestion documentaire",
      upload: "Téléverser",
      documentType: "Type de document",
      fileName: "Nom du fichier",
      fileSize: "Taille",
      uploadedBy: "Téléversé par",
      uploadedAt: "Téléversé le",
      download: "Télécharger",
      preview: "Aperçu",
      ocr: "Analyse OCR"
    },
    // Payments
    payments: {
      title: "Paiements judiciaires",
      newPayment: "Nouveau paiement",
      paymentType: "Type de paiement",
      fee: "Frais",
      fine: "Amende",
      tax: "Taxe",
      amount: "Montant",
      currency: "Devise",
      payerName: "Nom du payeur",
      status: "Statut",
      pending: "En attente",
      completed: "Complété",
      failed: "Échoué",
      pay: "Payer",
      receipt: "Reçu"
    },
    // Border Control
    border: {
      title: "Contrôle frontalier",
      newAlert: "Nouvelle alerte",
      alertType: "Type d'alerte",
      wanted: "Recherché",
      travelBan: "Interdiction de voyage",
      fugitive: "Fugitif",
      personName: "Nom de la personne",
      severity: "Gravité",
      high: "Haute",
      medium: "Moyenne",
      low: "Basse",
      lastSeen: "Dernière localisation"
    },
    // Clemency
    clemency: {
      title: "Module de grâce présidentielle",
      filterCandidates: "Filtrer les candidats",
      minAge: "Âge minimum",
      maxAge: "Âge maximum",
      minSentenceServed: "Peine minimum purgée (%)",
      generateList: "Générer la liste",
      candidates: "Candidats éligibles",
      exportList: "Exporter la liste"
    },
    // Admin
    admin: {
      title: "Administration",
      users: "Utilisateurs",
      roles: "Rôles",
      role: "Rôle",
      clearanceLevel: "Niveau d'habilitation",
      updateRole: "Mettre à jour le rôle"
    },
    // Audit
    audit: {
      title: "Journaux d'audit",
      action: "Action",
      resourceType: "Type de ressource",
      resourceId: "ID ressource",
      timestamp: "Horodatage",
      ipAddress: "Adresse IP",
      details: "Détails"
    },
    // Common
    common: {
      save: "Enregistrer",
      cancel: "Annuler",
      search: "Rechercher",
      filter: "Filtrer",
      export: "Exporter",
      import: "Importer",
      refresh: "Actualiser",
      loading: "Chargement...",
      noData: "Aucune donnée",
      error: "Erreur",
      success: "Succès",
      confirm: "Confirmer",
      back: "Retour",
      next: "Suivant",
      previous: "Précédent",
      selectAll: "Tout sélectionner",
      clearAll: "Tout effacer",
      republic: "République Démocratique du Congo",
      ministry: "Ministère de la Justice"
    },
    // Classifications
    classifications: {
      PUBLIC: "Public",
      RESTRICTED: "Restreint",
      CONFIDENTIAL: "Confidentiel",
      SECRET: "Secret",
      TOP_SECRET: "Très Secret"
    },
    // Roles
    roles: {
      CITIZEN: "Citoyen",
      // Police
      AGENT_POLICE: "Agent de police",
      POLICE_OFFICER: "Officier de police",
      OPJ: "Officier de Police Judiciaire (OPJ)",
      JUDICIAL_POLICE_OFFICER: "OPJ",
      COMMISSAIRE_ADJOINT: "Commissaire adjoint",
      COMMISSAIRE_PRINCIPAL: "Commissaire principal",
      // Border Control
      BORDER_CONTROL_OFFICER: "Agent de contrôle frontalier",
      BORDER_CONTROL_SUPERVISOR: "Superviseur frontières",
      // Tribunal de Paix
      GREFFIER_PAIX: "Greffier (Tribunal de Paix)",
      JUGE_PAIX: "Juge de Paix",
      PRESIDENT_TRIBUNAL_PAIX: "Président du Tribunal de Paix",
      // Parquet Grande Instance
      GREFFIER_GI: "Greffier (Grande Instance)",
      SUBSTITUT_PROCUREUR: "Substitut du Procureur",
      PROCUREUR_REPUBLIQUE: "Procureur de la République",
      // Cour d'Appel
      GREFFIER_APPEL: "Greffier (Cour d'Appel)",
      CONSEILLER_APPEL: "Conseiller (Cour d'Appel)",
      PRESIDENT_COUR_APPEL: "Président de la Cour d'Appel",
      // Parquet Général
      AVOCAT_GENERAL: "Avocat Général",
      PROCUREUR_GENERAL: "Procureur Général de la République",
      // Cour de Cassation
      GREFFIER_CASSATION: "Greffier (Cour de Cassation)",
      CONSEILLER_CASSATION: "Conseiller (Cour de Cassation)",
      PRESIDENT_CASSATION: "Président de la Cour de Cassation",
      // Conseil d'État
      GREFFIER_CONSEIL_ETAT: "Greffier (Conseil d'État)",
      CONSEILLER_ETAT: "Conseiller d'État",
      PRESIDENT_CONSEIL_ETAT: "Président du Conseil d'État",
      // Cour Suprême
      GREFFIER_COUR_SUPREME: "Greffier (Cour Suprême)",
      JUGE_SUPREME: "Juge à la Cour Suprême",
      PRESIDENT_COUR_SUPREME: "Président de la Cour Suprême",
      // Cour des Comptes
      AUDITEUR_COMPTES: "Auditeur (Cour des Comptes)",
      CONSEILLER_COMPTES: "Conseiller (Cour des Comptes)",
      PRESIDENT_COUR_COMPTES: "Président de la Cour des Comptes",
      // Auxiliaires de Justice
      HUISSIER: "Huissier de Justice",
      AVOCAT: "Avocat",
      BATONNIER: "Bâtonnier",
      // Prison
      GARDIEN_PRISON: "Gardien de Prison",
      CHEF_CACHOT: "Chef de Cachot",
      DIRECTEUR_PRISON: "Directeur de Prison",
      PRISON_OFFICER: "Agent pénitentiaire",
      PRISON_DIRECTOR: "Directeur de prison",
      // Administration
      SECRETAIRE_JURIDICTION: "Secrétaire de Juridiction",
      PROVINCIAL_ADMIN: "Administrateur provincial",
      NATIONAL_ADMIN: "Administrateur national",
      TECH_SUPPORT: "Support technique",
      // Oversight
      FINANCIAL_AUDITOR: "Auditeur financier",
      INSPECTEUR_JUDICIAIRE: "Inspecteur Judiciaire",
      // Executive
      MINISTER: "Ministre",
      MINISTRE_JUSTICE: "Ministre de la Justice",
      PREMIER_MINISTRE: "Premier Ministre",
      PRESIDENT: "Président de la République",
      // System
      SUPER_ADMIN: "Super Administrateur",
      MAGISTRATE: "Magistrat",
      CLERK: "Greffier"
    },
    // Institutions
    institutions: {
      SOUS_COMMISSARIAT: "Sous-commissariat de police",
      COMMISSARIAT: "Commissariat de police",
      CACHOT_COMMISSARIAT: "Cachot (Commissariat)",
      TRIBUNAL_PAIX: "Tribunal de Paix",
      CACHOT_TRIBUNAL_PAIX: "Cachot (Tribunal de Paix)",
      PARQUET_GRANDE_INSTANCE: "Parquet de Grande Instance",
      CACHOT_PARQUET_GI: "Cachot (Parquet GI)",
      COUR_APPEL: "Cour d'Appel",
      CACHOT_COUR_APPEL: "Cachot (Cour d'Appel)",
      PARQUET_GENERAL: "Parquet Général",
      COUR_COMPTES_PROV: "Cour des Comptes (Provincial)",
      PRISON_CENTRALE: "Prison Centrale",
      CONSEIL_ETAT: "Conseil d'État",
      COUR_CASSATION: "Cour de Cassation",
      COUR_SUPREME: "Cour Suprême",
      COUR_COMPTES_NAT: "Cour des Comptes (National)",
      PRISON_MAKALA: "Prison de Makala"
    }
  },
  en: {
    // Navigation
    nav: {
      dashboard: "Dashboard",
      cases: "Judicial Cases",
      prisoners: "Prisoners",
      documents: "Documents",
      payments: "Payments",
      borderControl: "Border Control",
      clemency: "Presidential Clemency",
      admin: "Administration",
      auditLogs: "Audit Logs",
      settings: "Settings",
      logout: "Logout"
    },
    // Auth
    auth: {
      login: "Login",
      register: "Register",
      email: "Email address",
      password: "Password",
      confirmPassword: "Confirm password",
      name: "Full name",
      loginButton: "Sign in",
      registerButton: "Sign up",
      googleLogin: "Continue with Google",
      noAccount: "No account?",
      hasAccount: "Already have an account?",
      forgotPassword: "Forgot password?",
      welcome: "Welcome to SNIGJ",
      subtitle: "National Integrated Justice Management System"
    },
    // Dashboard
    dashboard: {
      title: "Dashboard",
      totalCases: "Total Cases",
      openCases: "Open Cases",
      totalPrisoners: "Total Prisoners",
      pendingPayments: "Pending Payments",
      activeAlerts: "Active Alerts",
      recentActivity: "Recent Activity",
      quickActions: "Quick Actions",
      newCase: "New Case",
      newPrisoner: "New Prisoner",
      newDocument: "New Document",
      viewAll: "View All"
    },
    // Cases
    cases: {
      title: "Judicial Cases",
      newCase: "New Case",
      caseNumber: "Case Number",
      caseType: "Case Type",
      criminal: "Criminal",
      civil: "Civil",
      administrative: "Administrative",
      status: "Status",
      open: "Open",
      inProgress: "In Progress",
      pending: "Pending",
      closed: "Closed",
      archived: "Archived",
      classification: "Classification",
      jurisdiction: "Jurisdiction",
      parties: "Parties",
      charges: "Charges",
      description: "Description",
      createdAt: "Created at",
      updatedAt: "Updated at",
      actions: "Actions",
      view: "View",
      edit: "Edit",
      delete: "Delete"
    },
    // Prisoners
    prisoners: {
      title: "Prisoner Registry",
      newPrisoner: "New Prisoner",
      unji: "National ID (UNJI)",
      firstName: "First Name",
      lastName: "Last Name",
      dateOfBirth: "Date of Birth",
      gender: "Gender",
      male: "Male",
      female: "Female",
      nationality: "Nationality",
      status: "Status",
      preventive: "Preventive Detention",
      sentenced: "Sentenced",
      released: "Released",
      transferred: "Transferred",
      prison: "Prison",
      cell: "Cell",
      admissionDate: "Admission Date",
      sentenceStart: "Sentence Start",
      sentenceEnd: "Sentence End",
      biometricPhoto: "Biometric Photo",
      fingerprint: "Fingerprint"
    },
    // Documents
    documents: {
      title: "Document Management",
      upload: "Upload",
      documentType: "Document Type",
      fileName: "File Name",
      fileSize: "Size",
      uploadedBy: "Uploaded by",
      uploadedAt: "Uploaded at",
      download: "Download",
      preview: "Preview",
      ocr: "OCR Analysis"
    },
    // Payments
    payments: {
      title: "Judicial Payments",
      newPayment: "New Payment",
      paymentType: "Payment Type",
      fee: "Fee",
      fine: "Fine",
      tax: "Tax",
      amount: "Amount",
      currency: "Currency",
      payerName: "Payer Name",
      status: "Status",
      pending: "Pending",
      completed: "Completed",
      failed: "Failed",
      pay: "Pay",
      receipt: "Receipt"
    },
    // Border Control
    border: {
      title: "Border Control",
      newAlert: "New Alert",
      alertType: "Alert Type",
      wanted: "Wanted",
      travelBan: "Travel Ban",
      fugitive: "Fugitive",
      personName: "Person Name",
      severity: "Severity",
      high: "High",
      medium: "Medium",
      low: "Low",
      lastSeen: "Last Seen"
    },
    // Clemency
    clemency: {
      title: "Presidential Clemency Module",
      filterCandidates: "Filter Candidates",
      minAge: "Minimum Age",
      maxAge: "Maximum Age",
      minSentenceServed: "Minimum Sentence Served (%)",
      generateList: "Generate List",
      candidates: "Eligible Candidates",
      exportList: "Export List"
    },
    // Admin
    admin: {
      title: "Administration",
      users: "Users",
      roles: "Roles",
      role: "Role",
      clearanceLevel: "Clearance Level",
      updateRole: "Update Role"
    },
    // Audit
    audit: {
      title: "Audit Logs",
      action: "Action",
      resourceType: "Resource Type",
      resourceId: "Resource ID",
      timestamp: "Timestamp",
      ipAddress: "IP Address",
      details: "Details"
    },
    // Common
    common: {
      save: "Save",
      cancel: "Cancel",
      search: "Search",
      filter: "Filter",
      export: "Export",
      import: "Import",
      refresh: "Refresh",
      loading: "Loading...",
      noData: "No data",
      error: "Error",
      success: "Success",
      confirm: "Confirm",
      back: "Back",
      next: "Next",
      previous: "Previous",
      selectAll: "Select All",
      clearAll: "Clear All",
      republic: "Democratic Republic of Congo",
      ministry: "Ministry of Justice"
    },
    // Classifications
    classifications: {
      PUBLIC: "Public",
      RESTRICTED: "Restricted",
      CONFIDENTIAL: "Confidential",
      SECRET: "Secret",
      TOP_SECRET: "Top Secret"
    },
    // Roles
    roles: {
      CITIZEN: "Citizen",
      POLICE_OFFICER: "Police Officer",
      JUDICIAL_POLICE_OFFICER: "Judicial Police Officer",
      MAGISTRATE: "Magistrate",
      CLERK: "Clerk",
      PRISON_DIRECTOR: "Prison Director",
      PRISON_OFFICER: "Prison Officer",
      BORDER_CONTROL_OFFICER: "Border Control Officer",
      PROVINCIAL_ADMIN: "Provincial Administrator",
      NATIONAL_ADMIN: "National Administrator",
      TECH_SUPPORT: "Technical Support",
      FINANCIAL_AUDITOR: "Financial Auditor",
      MINISTER: "Minister",
      PRESIDENT: "President",
      SUPER_ADMIN: "Super Administrator"
    }
  },
  // LINGALA - National Language
  ln: {
    nav: {
      dashboard: "Tableau ya mosala",
      cases: "Makambo ya bosambisi",
      prisoners: "Bakangami",
      documents: "Mikanda",
      payments: "Mifuteli",
      borderControl: "Bokengeli ndelo",
      clemency: "Bolimbisi ya Mokonzi",
      admin: "Boyangeli",
      auditLogs: "Makomi ya bokengeli",
      settings: "Mibeko",
      logout: "Kobima"
    },
    auth: {
      login: "Kokota",
      register: "Komikoma",
      email: "Email",
      password: "Liloba ya kobombana",
      name: "Nkombo mobimba",
      loginButton: "Kota",
      registerButton: "Mikoma",
      googleLogin: "Kokota na Google",
      welcome: "Boyei malamu na SNIGJ",
      subtitle: "Système ya bosambisi ya mboka"
    },
    dashboard: {
      title: "Tableau ya mosala",
      totalCases: "Makambo nionso",
      openCases: "Makambo ya kofungwama",
      totalPrisoners: "Bakangami nionso",
      pendingPayments: "Mifuteli ya kozela",
      activeAlerts: "Mitindo ya kotinda"
    },
    common: {
      save: "Kobomba",
      cancel: "Kolongola",
      search: "Koluka",
      filter: "Kopona",
      loading: "Ezali kotala...",
      noData: "Makambo te",
      error: "Libunga",
      success: "Elongi",
      republic: "Republiki ya Demokratiki ya Kongo",
      ministry: "Ministère ya Bosambisi"
    },
    citizen: {
      myProfile: "Profil na ngai",
      myCases: "Makambo na ngai",
      myFees: "Mifuteli na ngai",
      fileComplaint: "Kotinda mpamba",
      messages: "Makomi",
      paymentHistory: "Historique ya mifuteli",
      travelBan: "Bokangami ya mobembo",
      lawyers: "Bavocats na ngai",
      family: "Libota na ngai"
    }
  },
  // SWAHILI - National Language
  sw: {
    nav: {
      dashboard: "Dashibodi",
      cases: "Kesi za mahakama",
      prisoners: "Wafungwa",
      documents: "Nyaraka",
      payments: "Malipo",
      borderControl: "Udhibiti wa mpaka",
      clemency: "Msamaha wa Rais",
      admin: "Utawala",
      auditLogs: "Kumbukumbu za ukaguzi",
      settings: "Mipangilio",
      logout: "Toka"
    },
    auth: {
      login: "Ingia",
      register: "Jisajili",
      email: "Barua pepe",
      password: "Nenosiri",
      name: "Jina kamili",
      loginButton: "Ingia",
      registerButton: "Jisajili",
      googleLogin: "Endelea na Google",
      welcome: "Karibu SNIGJ",
      subtitle: "Mfumo wa haki wa taifa"
    },
    dashboard: {
      title: "Dashibodi",
      totalCases: "Kesi zote",
      openCases: "Kesi zilizo wazi",
      totalPrisoners: "Wafungwa wote",
      pendingPayments: "Malipo yanayosubiri",
      activeAlerts: "Tahadhari zinazofanya kazi"
    },
    common: {
      save: "Hifadhi",
      cancel: "Ghairi",
      search: "Tafuta",
      filter: "Chuja",
      loading: "Inapakia...",
      noData: "Hakuna data",
      error: "Kosa",
      success: "Mafanikio",
      republic: "Jamhuri ya Kidemokrasia ya Kongo",
      ministry: "Wizara ya Haki"
    },
    citizen: {
      myProfile: "Wasifu wangu",
      myCases: "Kesi zangu",
      myFees: "Ada zangu",
      fileComplaint: "Wasilisha malalamiko",
      messages: "Ujumbe",
      paymentHistory: "Historia ya malipo",
      travelBan: "Marufuku ya kusafiri",
      lawyers: "Mawakili wangu",
      family: "Familia yangu"
    }
  },
  // KIKONGO - National Language
  kg: {
    nav: {
      dashboard: "Tablo ya kisalu",
      cases: "Mambu ma kifundu",
      prisoners: "Bakangwa",
      documents: "Mikanda",
      payments: "Mafutu",
      borderControl: "Kukeba ndelo",
      clemency: "Kiese kia Mfumu",
      admin: "Kiyangila",
      auditLogs: "Makombo ma kukeba",
      settings: "Nsiku",
      logout: "Kubaka"
    },
    auth: {
      login: "Kuingila",
      register: "Kusonika nkumbu",
      email: "Email",
      password: "Diambu dia kiwumbufu",
      name: "Nkumbu ya mvimba",
      loginButton: "Kuingila",
      registerButton: "Kusonika",
      googleLogin: "Kuingila na Google",
      welcome: "Mbote na SNIGJ",
      subtitle: "Système ya kifundu kia nsi"
    },
    common: {
      save: "Kusunda",
      cancel: "Kulembika",
      search: "Kutomba",
      filter: "Kusala",
      loading: "Kutala...",
      noData: "Mambu ve",
      error: "Mpasi",
      success: "Ntondele",
      republic: "Republiki Demokratiki ya Kongo",
      ministry: "Ministère ya Kifundu"
    },
    citizen: {
      myProfile: "Profil ami",
      myCases: "Mambu mami",
      myFees: "Mafutu mami",
      fileComplaint: "Kusala mpimpa",
      messages: "Makundu",
      paymentHistory: "Nsangu ya mafutu",
      travelBan: "Kukangama ya mpangu",
      lawyers: "Bavocats bami",
      family: "Dibundu diami"
    }
  },
  // TSHILUBA - National Language
  lu: {
    nav: {
      dashboard: "Tablo wa mudimu",
      cases: "Milumbu ya lubanza",
      prisoners: "Bakuatshiwa",
      documents: "Mikanda",
      payments: "Mifutu",
      borderControl: "Kulama ndelelu",
      clemency: "Luse lwa Mfumu",
      admin: "Bukalenge",
      auditLogs: "Mikanda ya kulama",
      settings: "Malu",
      logout: "Kupatuka"
    },
    auth: {
      login: "Kubuela",
      register: "Kuditela dina",
      email: "Email",
      password: "Dîyi dia kusokomena",
      name: "Dina dia mvimba",
      loginButton: "Kubuela",
      registerButton: "Kuditela",
      googleLogin: "Kubuela na Google",
      welcome: "Muoyo na SNIGJ",
      subtitle: "Système wa lubanza wa ditunga"
    },
    common: {
      save: "Kulama",
      cancel: "Kulekela",
      search: "Kukeba",
      filter: "Kusungula",
      loading: "Kutala...",
      noData: "Malu kadi",
      error: "Tshilema",
      success: "Dibanza",
      republic: "Ditunga dia Kongu wa Demokrasi",
      ministry: "Ministère wa Lubanza"
    },
    citizen: {
      myProfile: "Profil wanyi",
      myCases: "Milumbu yanyi",
      myFees: "Mifutu yanyi",
      fileComplaint: "Kuenza ndonge",
      messages: "Mêyi",
      paymentHistory: "Nsangu ya mifutu",
      travelBan: "Kukuatshiwa kwa luendu",
      lawyers: "Bavocats banyi",
      family: "Diku dianyi"
    }
  }
};

export const getTranslation = (lang, key) => {
  const keys = key.split('.');
  let value = translations[lang] || translations.fr;
  
  for (const k of keys) {
    value = value?.[k];
  }
  
  return value || key;
};

export const t = getTranslation;

// Available languages with their native names
export const AVAILABLE_LANGUAGES = [
  { code: 'fr', name: 'Français', native: 'Français' },
  { code: 'en', name: 'English', native: 'English' },
  { code: 'ln', name: 'Lingala', native: 'Lingála' },
  { code: 'sw', name: 'Swahili', native: 'Kiswahili' },
  { code: 'kg', name: 'Kikongo', native: 'Kikongo' },
  { code: 'lu', name: 'Tshiluba', native: 'Tshiluba' }
];

export default translations;
